import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SEO from '../../components/SEO'; // adjust path if needed

const NotFound = () => {
  const navigate = useNavigate();
  const [count, setCount] = useState(10);

  useEffect(() => {
    const timer = setInterval(() => {
      setCount((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/');
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <>
      <SEO title="404 - Page Not Found | Consumer Cloud Services" />

      <div className="min-h-screen bg-gray-950 flex items-center justify-center px-4 relative overflow-hidden">

        {/* Background grid */}
        <div
          className="absolute inset-0 opacity-10"
          style={{
            backgroundImage: `linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px),
                              linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)`,
            backgroundSize: '60px 60px',
          }}
        />

        {/* Glow blob */}
        <div className="absolute w-96 h-96 bg-blue-600 opacity-10 rounded-full blur-3xl top-1/4 left-1/2 -translate-x-1/2" />

        {/* Content */}
        <div className="relative z-10 text-center">

          {/* Error label */}
          <p className="text-blue-400 text-sm font-semibold tracking-widest uppercase mb-4">
            Error
          </p>

          {/* 404 */}
          <h1 className="text-[10rem] md:text-[14rem] font-black leading-none bg-gradient-to-br from-blue-400 to-blue-700 bg-clip-text text-transparent">
            404
          </h1>

          {/* Divider */}
          <div className="w-16 h-1 bg-blue-500 rounded mx-auto mb-6" />

          {/* Title */}
          <h2 className="text-white text-2xl md:text-3xl font-bold mb-3">
            Page Not Found
          </h2>

          {/* Description */}
          <p className="text-gray-400 text-base max-w-md mx-auto mb-4 leading-relaxed">
            The page you're looking for doesn't exist or has been moved.
          </p>

          {/* Countdown */}
          <p className="text-gray-500 text-sm mb-8">
            Redirecting to home in{' '}
            <span className="text-blue-400 font-bold text-base">{count}</span>s
          </p>

          {/* Button */}
          <button
            onClick={() => navigate('/')}
            className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold px-8 py-3 rounded-lg transition-colors duration-200"
          >
            ← Back to Home
          </button>

        </div>
      </div>
    </>
  );
};

export default NotFound;